module.exports = __webpack_public_path__ + "img/instagram.cb972474.svg";